import { Tooltip, TooltipProps } from '@mui/material';

interface TooltipWrapperProps extends TooltipProps {
  showTooltip?: boolean;
  children: JSX.Element;
}

const TooltipWrapper = ({
  showTooltip,
  title,
  placement,
  children,
}: TooltipWrapperProps) => {
  if (!showTooltip) return <>{children}</>;

  return (
    <Tooltip
      title={title}
      placement={placement || 'bottom'}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -12],
              },
            },
          ],
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipWrapper;
